import { connect } from "react-redux";
import { get } from "micro-dash";
import LocationsContainer from "./LocationsContainer";

function getOrganizationIdFromRouteParams(match) {
    const id = get(match, ["params", "organizationID"], null);
    if (Number.isNaN(parseInt(id))) {
        return null;
    }

    return parseInt(id);
}

const mapStateToProps = state => {
    const organizationDetailId = getOrganizationIdFromRouteParams(state.match);

    return {
        organization: state.entities.organizations.byId[organizationDetailId]
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LocationsContainer);
